import React, { useContext, useState, useEffect, Fragment } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { ChatContext } from '../../ChatProvider';
import { VideoContext } from '../../VideoProvider';
import Snackbar from '../../Snackbar/Snackbar';
import Snapshot from '../../../icons/Snapshot';
import useMediaStreamTrack from '../../../hooks/useMediaStreamTrack/useMediaStreamTrack';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
// import { isIOS } from '../../../utils';

export const SNAPSHOT_TEXT = 'Snapshot';

export default function ToggleSnapshotButton(props: { disabled?: boolean }) {
  const { setSnapImage, localTracks, snapSending, setSnapSending } = useContext(VideoContext);
  const { setIsChatWindowOpen } = useContext(ChatContext);
  const [activeSnack, setActiveSnack] = useState('');
  const videoTrack = localTracks.find(track => track.name.includes('camera'));
  const track = useMediaStreamTrack(videoTrack);
  const [, toggleVideoEnabled] = useLocalVideoToggle();

  useEffect(() => {
    if (!!activeSnack) {
      setTimeout(() => {
        setActiveSnack('');
      }, 5000);
    }
  }, [activeSnack]);

  const handleScreenshot = async () => {
    try {
      if (videoTrack) {
        setSnapSending(true);
        let blob = new Blob();
        var reader = new FileReader();
        if ('ImageCapture' in window) {
          const captureDevice = new ImageCapture(videoTrack.mediaStreamTrack);
          blob = await captureDevice.takePhoto();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            var base64 = reader.result as string;
            if (base64) {
              setSnapImage(base64);
              setIsChatWindowOpen(true);
            } else {
              setSnapSending(false);
              setActiveSnack("Couldn't capture snapshot");
            }
          };
        } else {
          const video = document.createElement('video');
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          const mode = track?.getSettings().facingMode;
          toggleVideoEnabled();

          const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: { facingMode: { exact: mode } },
          });

          let firstLoad = true;
          video.srcObject = stream;
          video.addEventListener('loadeddata', async () => {
            if (firstLoad) {
              const { videoWidth, videoHeight } = video;
              canvas.width = videoWidth;
              canvas.height = videoHeight;

              video.controls = false;
              video.muted = true;
              video.setAttribute('muted', ''); // Safe check
              video.setAttribute('playsinline', '');
              video.autoplay = true;
              setTimeout(async () => {
                await video.play();
                context!.drawImage(video, 0, 0, videoWidth, videoHeight);
                canvas.toBlob(blobObj => {
                  blob = blobObj!;
                  reader.readAsDataURL(blob);
                  reader.onloadend = () => {
                    var base64 = reader.result as string;
                    if (base64) {
                      firstLoad = false;
                      setSnapImage(base64);
                      setIsChatWindowOpen(true);
                      video.pause();
                      video.removeAttribute('src');
                      video.load();
                      // if (!isIOS()) {
                      setTimeout(() => {
                        toggleVideoEnabled(true);
                      }, 500);
                      // }
                    } else {
                      setSnapSending(false);
                      setActiveSnack("Couldn't capture snapshot");
                    }
                  };
                }, 'image/png');
              }, 50);
            }
          });
        }
      } else {
        setActiveSnack('You need to enable video to take snapshot');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
      <Snackbar headline="Error" message={activeSnack || ''} open={!!activeSnack} variant="error" />
      <Button
        disabled={snapSending}
        onClick={handleScreenshot}
        startIcon={snapSending ? <CircularProgress size={24} /> : <Snapshot />}
      >
        {SNAPSHOT_TEXT}
      </Button>
    </Fragment>
  );
}
